import React, { Component } from 'react';
import styled from 'styled-components';
import { Localize } from '../../../locale/localization';
import {
  Form,
  Input,
} from '../../common/components/form';
import Button from '../../../ui/button/Button';

import { formatProductDisplayName } from '../../../utils/content-utils';

import Table from '../../common/components/Table';

const StyledInput = styled(Input)`
  input {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
`;

class ProductScoresForm extends Component {

  renderProductRow = (product) => {
    const {
      productId,
      productCategory,
      score,
    } = product;

    const {
      onInputChange,
      errors,
      touchedFields,
    } = this.props;

    const displayName = formatProductDisplayName(product);

    return (
      <tr key={productId}>
        <td>{productCategory.name}</td>
        <td>{displayName}</td>
        <td>
          <StyledInput
            name={productId}
            type="text"
            value={score}
            error={errors[productId] && touchedFields.indexOf(productId) > -1}
            errorMessage={errors[productId]}
            onChange={onInputChange}
          />
        </td>
      </tr>
    );

  }
  render() {
    
    const {
      enabled,
      onSubmit,
      onBlur,
      onCancel,
      isValid,
      products,
    } = this.props;

    return (
      <Form
        onSubmit={onSubmit}
        autoCorrect="off"
        autoComplete="off"
        noValidate
        spellCheck="false"
        onBlur={onBlur}
      >
        <Table
          items={products}
          renderItem={this.renderProductRow}
          widths={['35%', '50%', '15%']}
        />
        <footer>
          <Button theme="light" onClick={onCancel}>{Localize('action.cancel')}</Button>
          <Button disabled={!isValid || !enabled} type="submit">{Localize('action.submit')}</Button>
        </footer>
      </Form>
    );
  }
};

export default ProductScoresForm;


// WEBPACK FOOTER //
// ./src/modules/product/components/ProductScoresForm.js